import { cn } from '@forest/shared'

export function InfiniteCarousel(props: {
  images: string[]
  gap: number
  className?: string
  duration?: number
}) {
  const { images, gap, duration = 20 } = props

  return (
    <div className={cn('overflow-hidden', props.className)}>
      <div
        className="flex h-full w-max"
        style={{
          animation: `scroll ${duration}s linear infinite`,
        }}
      >
        {[...images, ...images, ...images].map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            className="h-full w-auto rounded-[10px] border-[5px] border-white/10"
            style={{ marginRight: `${gap}px` }}
          />
        ))}
      </div>
    </div>
  )
}
